import { useState } from 'react';
import { useLocation } from 'react-router';
import { Paper, Stack } from '@mui/material';
import CandidateInfo from '../../components/SS/CandidateInfo';
import ProfileHeader from '../../components/SS/ProfileHeader';
import CandidateDetailsMain from '../../components/SS/main';

const CandidateDetails = () => {
  const { state } = useLocation();
  const [candidate, setCandidate] = useState(state);
  return (
    <Stack direction="column" height={1}>
      <ProfileHeader candidate={candidate} setCandidate={setCandidate} profile={false} />

      <Stack direction={{ xs: 'column', md: 'row' }} sx={{ height: 1 }}>
        <Paper background={1} sx={{ width: { md: 300, xl: 360 }, p: { xs: 3, lg: 5 } }}>
          <CandidateInfo
            contact={{
              email: state.email,
              phone: state.mobile,
              address: state.currentAddress,
            }}
            previous={{
              prevCTC: state.prevCTC,
              prevCompany: state.prevCompany,
              noticePeriod: state.noticePeriod,
            }}
            address={{
              currentAddress: state.currentAddress,
              permanentAddress: state.permanentAddress,
            }}
            experiences={{ qualification: state.qualification }}
          />
        </Paper>

        <Paper sx={{ flex: 1, p: { xs: 3, lg: 5 } }}>
          <CandidateDetailsMain state={state} profile={false} />
        </Paper>
      </Stack>
    </Stack>
  );
};

export default CandidateDetails;
